<script>
import {defineComponent} from 'vue'
import axios from 'axios'
export default defineComponent({
  name: "student-testy",
  props:['student'],
  data() {
    return {
      items: [],
      loading: true
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      axios.get('/student/testy.json', {params: {id: this.student}})
        .then(response => {
          this.items = response.data.items

        })
        .catch(error => {
          console.error("There was an error fetching the data:", error)
        })
        .finally(() => {
          this.loading = false
        })


    }
  }
})
</script>

<template>
  <div>
    <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>

    <div v-else>
      <div v-if="items.length === 0" class="no-results">
        Žádné výsledky.
      </div>
      <div v-else>
       <table class="table table-striped">
         <thead>
           <tr>
             <th>Submitted at</th>
             <th>Language</th>
             <th>Level</th>
             <th class="small">Score</th>
           </tr>
         </thead>
         <tbody>
           <tr v-for="(item, index) in items" :key="item.id || index">
             <td>{{ item.submitted_at }}</td>
             <td>{{ (item.test_lang || '').toString().toUpperCase() }}</td>
             <td>{{ item.level_by_score }}</td>
             <td class="small">{{ item.score }}</td>
           </tr>
         </tbody>
       </table>
      </div>
     </div>
   </div>
 </template>

 <style scoped>
 .spinner-container {
   display: flex;
   justify-content: center;
   align-items: center;
   min-height: 60px;
 }
 .spinner {
   width: 40px;
   height: 40px;
   border: 4px solid #eee;
   border-top: 4px solid #2196f3;
   border-radius: 50%;
   animation: spin 1s linear infinite;
 }
 .no-results {
   padding: 12px 8px;
   color: #666;
 }
 @keyframes spin {
   0% { transform: rotate(0deg);}
   100% { transform: rotate(360deg);}
 }
 </style>
